"use strict";
/**
 * @todo suporte para mais features
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.weight_by_dummy_names = exports.prune_ids = exports.get_dummies = exports.get_features_imovel = exports.features = void 0;
var mean_1 = require("./mean");
var std_deviation_1 = require("./std_deviation");
exports.features = {
    preco_venda: 'nonbinary',
    preco_locacao: 'nonbinary',
    tipo: 'binary-from-string',
    cidade_id: 'binary-from-number',
    estado_id: 'binary-from-number',
    //
    lat: 'nonbinary',
    long: 'nonbinary',
    dormitórios: 'nonbinary',
    vagas: 'nonbinary',
    suítes: 'nonbinary',
    banheiros: 'nonbinary',
    area_total: 'nonbinary',
    area_útil: 'nonbinary',
    area_privativa: 'nonbinary',
    area_construída: 'nonbinary',
    IPTU: 'nonbinary',
    preco_condominio: 'nonbinary',
};
/**
 * Cria um objeto de features baseado em um imóvel
 * @param imovel
 */
var get_features_imovel = function (imovel) {
    return {
        preco_venda: Number(imovel.preço_venda) || 0,
        ID: imovel.db_id,
        tipo: imovel.tipo || null,
        estado_id: imovel.estado ? String(imovel.estado.id || imovel.estado.value) || null : null,
        cidade_id: imovel.cidade ? String(imovel.cidade.id || imovel.cidade.value) || null : null,
        preco_locacao: Number(imovel.preço_locação) || 0,
        lat: Number(imovel.lat) || 0,
        long: Number(imovel.long) || 0,
        dormitórios: Number(imovel.dormitórios) || 0,
        vagas: Number(imovel.vagas) || 0,
        suítes: Number(imovel.suítes) || 0,
        banheiros: Number(imovel.banheiros) || 0,
        area_total: Number(imovel.area_total) || 0,
        area_útil: Number(imovel.area_útil) || 0,
        area_privativa: Number(imovel.area_privativa) || 0,
        area_construída: Number(imovel.area_construída) || 0,
        IPTU: Number(imovel.IPTU) || 0,
        preco_condominio: Number(imovel.preço_condominio) || 0,
    };
};
exports.get_features_imovel = get_features_imovel;
var notwanted_features = Object.entries(exports.features)
    .map(function (_a) {
    var feature = _a[0], type = _a[1];
    return (type.startsWith('binary') ? feature : '');
})
    .filter(function (feature) { return feature !== ''; })
    .reduce(function (prev, curr) {
    // adiciona [x_null, x_true, x_undefined, x] a array
    return (prev = prev.concat(__spreadArrays(['_null', '_true', '_undefined'].map(function (to_be_deleted) { return curr + to_be_deleted; }), [
        curr,
    ])));
}, []);
/**
 * Funcao que transforma uma lista de imoveis para adicionar variaveis "dummy"
 * "uma variável dummy é aquela que leva apenas o valor 0 ou 1 para indicar a ausência ou
 * presença de algum efeito categórico que pode mudar o resultado."
 * @param {ImovelInput[]} imoveis
 * @name "get_dummies" é o mesmo nome da função do package "pandas" usado em python. https://pandas.pydata.org/pandas-docs/stable/reference/api/pandas.get_dummies.html
 * @returns Uma array de mesmo tamanho da array de input
 */
var get_dummies = function (imoveis) {
    var features_entries = Object.entries(exports.features);
    // Usando Set para não ter que se preucupar com strings repetidas
    var possible_vars = new Set(features_entries.filter(function (_a) {
        var feature = _a[0], type = _a[1];
        return type === 'nonbinary';
    }).map(function (_a) {
        var name = _a[0];
        return name;
    }));
    for (var _i = 0, imoveis_1 = imoveis; _i < imoveis_1.length; _i++) {
        var imovel = imoveis_1[_i];
        for (var _a = 0, features_entries_1 = features_entries; _a < features_entries_1.length; _a++) {
            var _b = features_entries_1[_a], feature = _b[0], type = _b[1];
            if (type === 'binary-from-number' || type === 'binary-from-string') {
                if (imovel[feature] && typeof imovel[feature] === 'string')
                    possible_vars.add(feature + "_" + imovel[feature]);
            }
        }
    }
    for (var _c = 0, notwanted_features_1 = notwanted_features; _c < notwanted_features_1.length; _c++) {
        var feature = notwanted_features_1[_c];
        possible_vars.delete(feature);
    }
    var dummy_names = Array.from(possible_vars);
    var imoveis_with_dummies = imoveis.map(function (imovel) {
        /**
         * Criar shallow copy do objeto, assim o objeto original não é mutado
         * @see https://medium.com/@manjuladube/understanding-deep-and-shallow-copy-in-javascript-13438bad941c
         */
        var imovel_with_dummies = __assign({}, imovel);
        for (var _i = 0, dummy_names_1 = dummy_names; _i < dummy_names_1.length; _i++) {
            var dummy = dummy_names_1[_i];
            for (var _a = 0, features_entries_2 = features_entries; _a < features_entries_2.length; _a++) {
                var _b = features_entries_2[_a], feature = _b[0], type = _b[1];
                if (dummy.startsWith(feature + '_')) {
                    var dummy_value = imovel[feature] == dummy.replace(feature + '_', '') ? 1 : 0;
                    imovel_with_dummies[dummy] = dummy_value;
                }
            }
        }
        for (var _c = 0, notwanted_features_2 = notwanted_features; _c < notwanted_features_2.length; _c++) {
            var i_var = notwanted_features_2[_c];
            delete imovel_with_dummies[i_var];
        }
        return imovel_with_dummies;
    });
    return {
        imoveis_with_dummies: imoveis_with_dummies,
        dummy_names: dummy_names,
    };
};
exports.get_dummies = get_dummies;
/**
 * Remove o parametro ID de um imóvel, com dummies, de input
 * @param imovel
 */
var prune_ids = function (imovel) {
    var imovel_copy = __assign({}, imovel);
    delete imovel_copy.ID;
    return Object.values(imovel_copy);
};
exports.prune_ids = prune_ids;
/**
 * Função que cria um peso para cada feature, talvez possa receber hyperparametros
 * @todo hyperparametros
 * @param dummy_names
 * @param sample_size
 */
var weight_by_dummy_names = function (dummy_names, imoveis_with_dummies, calc_type, custom_w_fn) {
    if (calc_type === void 0) { calc_type = 'default'; }
    // Remover discrepancias extremas de preços
    if (calc_type === 'no-outliers') {
        var p_venda = [];
        var p_locacao = [];
        for (var _i = 0, imoveis_with_dummies_1 = imoveis_with_dummies; _i < imoveis_with_dummies_1.length; _i++) {
            var imovel = imoveis_with_dummies_1[_i];
            p_venda.push(imovel.preco_venda);
            p_locacao.push(imovel.preco_locacao);
        }
        /**
         * @todo
         */
        var mean_venda = mean_1.default(p_venda);
        var stdd_venda = std_deviation_1.default(p_venda);
    }
    // Função de gerar weights customizada
    if (calc_type === 'custom' && custom_w_fn !== undefined)
        return custom_w_fn(dummy_names, imoveis_with_dummies);
    return dummy_names.map(function (name) {
        if (name.startsWith('cidade_id_'))
            return 1 / dummy_names.filter(function (n) { return n.startsWith('cidade_id_'); }).length;
        if (name.startsWith('estado_id_'))
            return 1 / dummy_names.filter(function (n) { return n.startsWith('estado_id_'); }).length;
        if (name.startsWith('tipo_'))
            return 1 / dummy_names.filter(function (n) { return n.startsWith('tipo_'); }).length;
        // Provavelmente é melhor fazer 1 ser o valor mais alto, provavelmente isso ai em baixo pode ta fodendo os calculos "um pouco",
        // Mas os hyperparametros vão corrigir isso
        if (name.startsWith('preco_locacao'))
            return calc_type === 'alt' ? 0.1 : 2.5; // 1;
        if (name.startsWith('preco_venda'))
            return calc_type === 'alt' ? 1 : 2.5; // 1;
        return calc_type === 'alt' ? (1 / (dummy_names.length / 1.9)) : 1 / dummy_names.length; // (1 / dummy_names.length) / 2
    });
};
exports.weight_by_dummy_names = weight_by_dummy_names;
